document.addEventListener('DOMContentLoaded', function() {
    // Функция для создания бегущей строки
    const setupMarquee = () => {
        // Проверяем ширину экрана
        const isMobile = window.innerWidth < 768;
        
        // Находим все элементы marquee-content
        const marqueeElements = document.querySelectorAll('.marquee-content');
        
        marqueeElements.forEach(element => {
            // Получаем текущее содержимое
            const originalContent = element.innerHTML;
            
            // На мобильных устройствах размножаем контент
            if (isMobile) {
                // Проверяем, размножили ли мы уже контент
                if (!element.classList.contains('marquee-initialized')) {
                    // Создаем внутренний контейнер для бегущей строки, чтобы не конфликтовать с rotate
                    const innerContainer = document.createElement('div');
                    innerContainer.classList.add('marquee-inner');
                    
                    // Подготавливаем содержимое, заменяя активный таймер на плейсхолдер для копий
                    let contentForSpans = originalContent;
                    
                    // Специальная обработка для таймера - только в первом экземпляре оставляем активный класс
                    if (contentForSpans.includes('start__marque__timer')) {
                        contentForSpans = contentForSpans.replace('start__marque__timer', 'timer-placeholder');
                    }
                    
                    // Определяем количество копий, чтобы гарантировать заполнение экрана
                    // Чем больше копий, тем более бесшовным будет эффект
                    const copies = 8; // Увеличиваем количество для большей плавности
                    
                    // Оборачиваем оригинальное содержимое в span
                    let newContent = `<span class="marquee-item">${originalContent}</span>`;
                    
                    // Добавляем копии
                    for (let i = 0; i < copies; i++) {
                        newContent += `<span class="marquee-item">${contentForSpans}</span>`;
                    }
                    
                    // Заполняем внутренний контейнер
                    innerContainer.innerHTML = newContent;
                    
                    // Очищаем элемент и добавляем внутренний контейнер
                    element.innerHTML = '';
                    element.appendChild(innerContainer);
                    element.classList.add('marquee-initialized');
                    
                    // Добавляем инлайновую анимацию к внутреннему контейнеру (важно!)
                    // Это позволит избежать конфликта с transform:rotate на родительском элементе
                    setTimeout(() => {
                        const contentWidth = innerContainer.scrollWidth / (copies + 1);
                        const duration = contentWidth / 50; // Скорость зависит от длины контента
                        
                        innerContainer.style.animation = `marqueeAnimation ${duration}s linear infinite`;
                        
                        // Создаем CSS для анимации, если его еще нет
                        if (!document.getElementById('marquee-animation-style')) {
                            const style = document.createElement('style');
                            style.id = 'marquee-animation-style';
                            style.innerHTML = `
                                @keyframes marqueeAnimation {
                                    0% { transform: translateX(0); }
                                    100% { transform: translateX(-${contentWidth}px); }
                                }
                            `;
                            document.head.appendChild(style);
                        }
                    }, 100);
                }
            } else {
                // На десктопе возвращаем исходное содержимое
                if (element.classList.contains('marquee-initialized')) {
                    element.innerHTML = originalContent;
                    element.classList.remove('marquee-initialized');
                }
            }
        });
    };
    
    // Вызываем функцию при загрузке
    setupMarquee();
    
    // И при изменении размера окна
    window.addEventListener('resize', setupMarquee);
});
